import React from 'react';
import { Img, ImgProps } from 'react-image';
import classNames from 'classnames';
import { Skeleton } from 'antd';
import Loading from '../Loading';
import './styles.scoped.css';

interface ImageProps extends ImgProps {
  width?: string | number;
  height?: string | number;
  bordered?: boolean;
  containerStyle?: React.CSSProperties;
}

const loader = <Loading />;

function Image(props: ImageProps) {
  const { height = 130, width = height, bordered = false, containerStyle, ...rest } = props;
  return (
    <div
      className={classNames('image-container', { bordered })}
      style={{ width, height, ...containerStyle }}
    >
      <Img loader={loader} unloader={<Skeleton.Image />} decode={false} {...rest} />
    </div>
  );
}

export default Image;
